// test2442
(2442 && 0);
